// ver1.0.1

// topタブ
$(window).on('load',function(){
  var windowWidth = $(window).width();
  if (windowWidth < 992) {
    $('#shopify-section-template--24199962689824__featured_collection_M8iBL7 .grid').insertAfter(".tab .tabContents .js-spgoods");
    $('#shopify-section-template--24199962689824__featured_collection_yabYz7 .grid').insertAfter(".tab .tabContents .js-gift");
    $('#shopify-section-template--24199962689824__featured_collection_UQhRN6 .grid').insertAfter(".tab .tabContents .js-pukupuku");
    $('#shopify-section-template--24199962689824__featured_collection_pxKQpB .grid').insertAfter(".tab .tabContents .js-tumbler");
    $('#shopify-section-template--24199962689824__featured_collection_6JjzUh .grid').insertAfter(".tab .tabContents .js-dog");
    $('#shopify-section-template--24199962689824__featured_collection_rtHT8G .grid').insertAfter(".tab .tabContents .js-kids");
    $('#shopify-section-template--24199962689824__featured_blog_LVwPp8').insertBefore("#shopify-section-template--24199962689824__rich_text_yFbXmJ");
    $('#shopify-section-template--24199962689824__custom_liquid_ac9gHG .conceptA').insertBefore("#shopify-section-template--24199962689824__rich_text_yFbXmJ");
  }
});

// ヒーローヘッダー　100vhのスマホ対応
function setHeight() {
  let vh = window.innerHeight * 0.01;
}
setHeight();

var menuState = false;
var dropState = false;

window.addEventListener("load", function () {
  $('.mainSlider--typeB').each(function(){
    var slider = $(this); // スライダー
    var thumbnailItem = ".msThumbnail .msThumbnail__item"; // サムネイル画像アイテム

    var data = $(this).data();
    var arrow = true;
    if(data['arrow'] == 'false') arrow = false;

    // サムネイル画像アイテムに data-index でindex番号を付与
    $(thumbnailItem).each(function(){
    var index = $(thumbnailItem).index(this);
    $(this).attr("data-index",index);
    });

    // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
    // 「slickスライダー作成」の前にこの記述は書いてください。
    $(slider).on('init',function(slick){
    var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
    $(thumbnailItem+'[data-index="'+index+'"]').addClass("thumbnail-current");
    });

    //slickスライダー初期化
    $(slider).slick({
      autoplay: true,
      arrows: arrow,
      infinite: true,
    });
    //サムネイル画像アイテムをクリックしたときにスライダー切り替え
    $(thumbnailItem).on('click',function(){
      var index = $(this).attr("data-index");
      $(slider).slick("slickGoTo",index,false);
    });

    //サムネイル画像のカレントを切り替え
    $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
      $(thumbnailItem).each(function(){
        $(this).removeClass("thumbnail-current");
      });
      $(thumbnailItem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
    });
  });
});

// SPのみアコーディオン
$(document).on("click", ".sp-toggle", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(this).next("ul").slideToggle();
    $(this).toggleClass("open");
  }
});

$(document).on("click", ".hdrSearch--toggle > span,.hdrSearch--toggle > a", function () {
  const $this = $(this);
  const $icon = $this.find(".material-icons");
  const iconText = $icon.text();

  $this.next().slideToggle();
  if (iconText === "search") {
    $icon.text("close");
  } else if (iconText === "close") {
    $icon.text("search");
  }

  return false;
});


// ナビゲーション　子要素展開
$(function () {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if (
    ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
      ua.indexOf("Mobile") > 0) ||
    ua.indexOf("iPad") > 0
  ) {
    $(".hasChildren > a")
      .on("mouseenter touchstart", function () {
        $(this).toggleClass("open");
        $(this).next("ul,.megaMenu").toggleClass("open");
        return false;
      })
      .on("mouseleave touchend", function () {
        return false;
      });
    $(".hasChildren .hasChildren--close > a").on(
      "mouseenter touchstart",
      function () {
        $(this).parents("ul").removeClass("open").prev("a").removeClass("open");
        return false;
      }
    );
  } else {
    // PC時
    $(".hasChildren")
      .on("mouseenter focusin", function () {
        $(this).children("a").addClass("open");
        $(this).children("ul,.megaMenu").addClass("open");
      })
      .on("mouseleave focusout", function () {
        $(this).children("a").removeClass("open");
        $(this).children("ul,.megaMenu").removeClass("open");
      });
  }
});

$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span,.hasChildren--click > h3', function() {
  const $this = $(this);
  const $ul = $this.next('ul');

  if ($this.hasClass('open')) {
    $this.removeClass('open');
    $ul.removeClass('open').slideUp();
  } else {
    const $gNav = $this.closest('.gNav');
    $gNav.find('.hasChilds > span').removeClass('open');
    $gNav.find('.hasChilds > span').next('ul').removeClass('open').slideUp(0);
    $this.addClass('open');
    $ul.addClass('open').slideDown();
  }

  return false;
});


$(document).on("click", ".hasChildren--clickSP > h2", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    var next = $(this).next();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      next.removeClass("open");
      next.slideUp();
    } else {
      const all = $(this)
        .parents("li")
        .parents()
        .parents(".gNav")
        .find(".hasChilds > span");
      all.removeClass("open");
      all.next().removeClass("open").slideUp(0);
      $(this).addClass("open");
      next.addClass("open").slideDown();
    }
    return false;
  }
});

// マルチグリッド横スクロール
$(function () {
  $(".lightSlider .multiGrid").each(function () {
    const $grid = $(this);
    const $slider = $grid.parents(".lightSlider");

    $grid.after('<div class="prevBtn"></div>', '<div class="nextBtn"></div>');

    const $leftButton = $grid.next(".prevBtn");
    const $rightButton = $leftButton.next(".nextBtn");

    let width = 0;
    $grid.children("li").each(function () {
      width += $(this).outerWidth(true);
    });

    //右へ
    $rightButton.click(function () {
      $grid.animate({ scrollLeft: $grid.scrollLeft() + 600 }, 300);
      return false;
    });

    //左へスクロールで表示
    $grid.scroll(function () {
      if ($grid.scrollLeft() < width - $grid.width()) {
        $rightButton.fadeIn();
      } else {
        $rightButton.fadeOut();
      }
    });

    //左へ
    $leftButton.click(function () {
      $grid.animate({ scrollLeft: $grid.scrollLeft() - 600 }, 300);
      return false;
    });

    //右へスクロールで表示
    $leftButton.hide();
    $grid.scroll(function () {
      if ($grid.scrollLeft() > 0) {
        $leftButton.fadeIn();
      } else {
        $leftButton.fadeOut();
      }
    });
  });
});




// テキスト横スクロール
var spSwiperDone = false;
$(window).on("load resize", function (event) {
  if (
    window.innerWidth < 992 &&
    spSwiperDone == false &&
    $(".spSwiper").length
  ) {
    $(".spSwiper").slick({
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: false,
    });

    spSwiperDone = true;
  }
});

// タブ切り替え
$(function() {
  $(".tabSwitch > li").on('click', function() {
    var $this = $(this);
    if (!$this.hasClass('active')) {
      $this.siblings().removeClass('active');
      $this.addClass('active');

      var tabNum = $this.index();
      var $tabContents = $this.closest(".tab").find(".tabContent");

      $tabContents.hide().eq(tabNum).fadeIn("500");
    }
  });
});

$(function() {
  if ($(".wow").length) {
    $(window).on("scroll", function () {
      $(".wow").each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > position - windowHeight + windowHeight / 4) {
          $(this).addClass("animated");
        }
      });
    });
  }
});

if (window.innerWidth < 767) {
  $(".cateList__hasChildren").click(function () {
    $(this).toggleClass("open").next().toggleClass("open").slideToggle();
    return false;
  });
}
